import { DropdownMultiSelect } from "@/components/form-control";
import { FilterUrbanFeature } from "@/modules/urban-feature/hooks/use-search-filter-urban-feature";
import { urbanFeatureValue } from "@/modules/urban-feature/urban-feature.const";
import { UrbanFeatureType } from "@/types/gql/graphql";

type UrbanFeatureFilterProps = {
  selectedUrbanTypes: UrbanFeatureType[];
  onChange: (input: FilterUrbanFeature) => void;
  className?: string;
};

export type UrbanOptions = {
  value: UrbanFeatureType;
  label: string;
};

const urbanOptions: UrbanOptions[] = Object.entries(urbanFeatureValue).map(([key, label]) => ({
  value: key as UrbanFeatureType,
  label,
}));

export const UrbanFeatureFilter = ({ selectedUrbanTypes, onChange }: UrbanFeatureFilterProps) => {
  const selectItem = (value: UrbanFeatureType[]) => {
    onChange({ selectedUrbanTypes: value });
  };

  return (
    <DropdownMultiSelect
      options={urbanOptions}
      values={selectedUrbanTypes}
      onChangeValues={selectItem}
      placeholder="Type de urban feature"
    />
  );
};
